import React from "react";
import Modal from "react-bootstrap/esm/Modal";
import Button from "react-bootstrap/Button";
import AppStateModel from "../../../models/appStateModel";
import {useDispatch, useSelector} from "react-redux";
import LookupModel from "../../../models/lookupModel";
import Select from "react-select";
import {setShipmentsCriteriaAsync} from "../../../actions/shipmentsActions";

interface IProps {
    visible: boolean;
    onHide: () => any;
    onDone: (ids: string[], customerId: string) => void;
    title: string;
    submitButton: string;
    selectedIds: string[];
    allowedStatuses?: string[];
}

const BulkPickedUpModal = (props: IProps) => {
    const dispatch = useDispatch()
    const [courier, setCourier] = React.useState<any>(null);
    const couriers = useSelector((state: AppStateModel) => state.Meta?.couriers);
    const customers = useSelector((state: AppStateModel) => state.Meta?.couriers);
    const meta = useSelector((state: AppStateModel) => state.Meta);
    const [selectedCustomer, setSelectedCustomer] = React.useState<LookupModel | undefined>();

    const onSubmit = () => {
        props.onDone(props.selectedIds, selectedCustomer?.value!);
    };

    const countryCode = useSelector(
        (state: AppStateModel) => state.Profile.currentTenant?.countryCode
    );

    return (
        <Modal
            show={props.visible}
            onHide={() => props.onHide()}
            dialogClassName="modal-100w"
            aria-labelledby="example-custom-modal-styling-title"
            size="lg"
        >
            <Modal.Header closeButton>
                <Modal.Title id="example-custom-modal-styling-title">
                    {props.title}
                </Modal.Title>
            </Modal.Header>
            <Select
                key={`selectedCustomer`}
                value={selectedCustomer}
                options={meta?.customers?.filter(i => i.label == "Geidea") ?? []}
                isClearable
                placeholder={'Select Customer'}
                onChange={(selectedOption) => {
                    setSelectedCustomer({
                        label: selectedOption?.label!,
                        value: selectedOption?.value!,
                    });

                    dispatch(
                        //@ts-ignore
                        setShipmentsCriteriaAsync({
                            //@ts-ignore
                            CustomerId: selectedOption?.value,
                        })
                    );
                }}
            />
            <Modal.Footer>

                <Button
                    disabled={!selectedCustomer}
                    onClick={onSubmit}
                >
                    {props.submitButton}
                </Button>
            </Modal.Footer>
        </Modal>
    );
};

export default BulkPickedUpModal;
